import { ExternalHyperlink, InternalHyperlink } from 'docx';
import type { NodeEntry } from 'slate';

import type { DocumentContext } from './internal';
import { createParagraphChild } from './internal';
import type { LinkElement } from '../../../slate-api';
import type { UUID } from '../../../types/type-helpers';
import { parseLink } from '../../../util';

export type HyperlinkRefIds = Map<LinkElement, UUID>;

export function createHyperlink(
  linkEntry: NodeEntry<LinkElement>,
  options: { context: DocumentContext }
): InternalHyperlink | ExternalHyperlink {
  const [link, linkPath] = linkEntry;
  const { children, href } = link;

  const serializedChildren = children.flatMap((child, index) =>
    createParagraphChild([child, linkPath.concat(index)], options)
  );

  const parsedLink = parseLink(href);

  if (parsedLink.type === 'bookmark') {
    return new InternalHyperlink({ anchor: parsedLink.bookmark, children: serializedChildren });
  }

  return new ExternalHyperlink({
    children: serializedChildren,
    link: href,
  });
}
